<style scoped>
.image-prop-wrapper{
    display: flex;
}
.prop-image-upfile{
    display: inline-block;
    position: relative;
}
.image-file{
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    opacity: 0;
    width: 100%;
    height: 100%;
}
</style>
<template>
    <span class="image-prop-wrapper">
        <Input v-model="text" @on-change="changed" size="small"/>
        <div class="prop-image-upfile">
            <input type="file" @change="handlerUpfile" ref="file" class="image-file">
            <Button type="primary" size="small">上传图片</Button>
        </div>
    </span>
</template>
<script>
    import { uploadImageFile } from '@/web/api/props';
    export default {
        props: ["value"],
        data() {
            return {
                text: "",
                timer: null,
                upfile: ''
            }
        },
        watch: {
            value: {
                handler(value) {
                    this.text = value;
                },
                immediate: true
            }
        },
        methods: {
            changed() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$emit("input", this.text)
                    this.$emit('save')
                }, 1000);

            },
            handlerUpfile(e){
                const target = this.$refs.file;
                const files = target.files[0];
                const formData = new FormData();
                formData.append('file',files);
                uploadImageFile(formData).then(res=>{
                    if(res){
                       this.text = `/api/${res}`;
                       this.$emit("input", this.text)
                       this.$emit('save');
                    }
                })
            }
        }
    }
</script>